import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  TextField,
  Button,
  IconButton,
  Divider,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import SaveIcon from "@mui/icons-material/Save";
import DeleteIcon from '@mui/icons-material/Delete';
import CancelIcon from "@mui/icons-material/Cancel";
import CheckIcon from '@mui/icons-material/Check';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { userAgentNotesAdd, userAgentNotesDelete, userAgentNotesUpdate } from "../../../util/API/customers";
import CustomAlert from "../../UI/CustomAlert/CustomAlert";
import { commonRunQuery } from "../../../util/API/loans";
import { decodeHtmlEntities } from "../../../util/utilfunctions/utilFunctions";
function formatDate(dateStr) {
  const date = new Date(dateStr);
  return date.toLocaleString();
}

const dummyAgent = "Agent John"; // simulate current user

const initialNotes = [
  {
    id: 1,
    content: "Initial account setup completed.",
    createdAt: "2025-06-20T10:25:00",
    updatedAt: null,
    author: "Agent Alice",
    isEditing: false,
  },
  {
    id: 2,
    content: "Followed up on documentation via email.",
    createdAt: "2025-06-19T09:45:00",
    updatedAt: "2025-06-19T11:00:00",
    author: "Agent Bob",
    isEditing: false,
  },
];

function UserNotes({ selectedUser, selectedUserData, isSuperAdmin, setSelectedUserData }) {
    const [notes, setNotes] = useState(null);
    const [newNote, setNewNote] = useState("");
    const [isLoading, setIsLoading] = useState("");
    const authUser = JSON.parse(sessionStorage.getItem("user"));
    const [alert, setAlert] = useState({
        showAlert: false,
        message: "",
        severity: "",
        header: "",
        type: "",
    });
    const [alertNew, setAlertNew] = useState({
        showAlert: false,
        severity: "",
        header: "",
        message: "",
        onConfirm: null,
        alertType: ''
    });

  let isAdmin = sessionStorage.getItem("isAdmin");
//   console.log("isAdminnnnn============",isAdmin);
//   console.log("isSuperAdminnnnn============",isSuperAdmin);

    useEffect(()=> {
        getUserNotes();
    },[]);

    const getUserNotes = async() => {
        try {
            const response = await commonRunQuery(300, selectedUser);
            // console.log("getUserNotes_response============",response);
            if (response?.data?.header?.callStatus == "1") {

                const notesArr = Array.isArray(response?.data?.body?.record)
                    ? response?.data?.body?.record
                    : [response?.data?.body?.record];

                const transformedNotes = notesArr.map((item) => ({
                    id: item.un.noteid,
                    content: item.un.notes,
                    createdAt: item.un.notedatetime,
                    updatedAt: null, // Add if your DB has it later
                    author: item.record.createdByFullName,
                    isEditing: false,
                }));
          
                setNotes(transformedNotes);
            } else {
                setNotes([]);
            }
        } catch (error) {
            
        } finally {

        }
    }

    const handleSaveNewNote = async() => {
        if (!newNote.trim()) return;

        try {
            setIsLoading(false);
            const response = await userAgentNotesAdd(selectedUser, authUser?.userid, newNote);
            // console.log("handleSaveNewNote_response----------",response);

            if(response?.data?.header?.callStatus == "1") {
                setAlert({
                    showAlert: true,
                    message: `Note added successfully!`,
                    severity: "success",
                    header: "Congratulations!",
                });

                setNewNote("");
                getUserNotes();
            } else {
                setAlert({
                    showAlert: true,
                    message: `Failed to add note.`,
                    severity: "error",
                    header: "Error!",
                });
            }
        } catch (error) {
            console.log("handleSaveNewNote_error---------------",error);
            setAlert({
                showAlert: true,
                message: `Failed to add note.`,
                severity: "error",
                header: "Error!",
            });
        } finally {
            setIsLoading(false);
        }
    };

    const handleEditToggle = (id) => {
        setNotes(notes?.map(n => n.id === id ? { ...n, isEditing: !n.isEditing } : n));
        notes.map(note => {
            console.log("note============",note);
        });
    };

    const handleEditSave = async(id, content) => {
        try {
            if (!content.trim()) return;

            const response = await userAgentNotesUpdate(selectedUser, authUser?.userid, content, id );
            if(response?.data?.header?.callStatus == "1" ){
                setAlert({
                    showAlert: true,
                    message: `Note updated successfully!`,
                    severity: "success",
                    header: "Congratulations!",
                });
                getUserNotes();
            } else {
                setAlert({
                    showAlert: true,
                    message: `Failed to update note.`,
                    severity: "error",
                    header: "Error!",
                });
            }
            // console.log("handleEditSave_response---------------",response);
        } catch (error) {
            console.log("handleEditSave_error---------------",error);
        }
        
        // setNotes(notes?.map(n => n.id === id ? {
        //     ...n,
        //     content,
        //     updatedAt: new Date().toISOString(),
        //     isEditing: false,
        // } : n));
    };

    const toggleNoteExpand = (id) => {
        setNotes(notes.map(note =>
          note.id === id ? { ...note, expanded: !note.expanded } : note
        ));
    };

    const handleDeleteNote = async(noteid) => {
        // console.log("handleDeleteNote_noteid-------------",noteid);
        try {
            const response = await userAgentNotesDelete(selectedUser, noteid);
            // console.log("handleDeleteNote_response-------------",response);
            if(response?.data?.header?.callStatus == "1") {
                setAlert({
                    showAlert: true,
                    message: `Note deleted successfully!`,
                    severity: "success",
                    header: "Congratulations!",
                });

                getUserNotes();
            }
        } catch (error) {
            console.log("handleDeleteNote_error========",error);
        }
    }

    const handleDeleteConfirmation = (noteid) => {
        setAlertNew({
          ...alertNew,
          showAlert: true,
          message: "Are you sure you want to delete this note?",
          severity: "confirm",
          header: "Please Confirm",
          alertType: 'confirm',
          onConfirm: () => handleDeleteNote(noteid)
        })
    }

    return (
        <Box className="user-notes-container">
            <Typography variant="h6" gutterBottom>User Notes</Typography>

            {/* Add Note */}
            <Box className="add-note-box">
                <TextField
                multiline
                fullWidth
                rows={3}
                placeholder="Add a new note..."
                value={newNote}
                onChange={(e) => setNewNote(e.target.value)}
                spellCheck={true}
                />
                <Button variant="contained" onClick={handleSaveNewNote} className="save-note-button" sx={{ mt: 1 }}>
                Save Note
                </Button>
            </Box>

            <Divider sx={{ my: 2 }} />

            <Box className="notes-scroll-container">
                {/* Notes List */}
                {notes?.map(note => (
                    <Box key={note.id} className="note-item">
                        {note.isEditing ? (
                            <>
                            <TextField
                                multiline
                                fullWidth
                                rows={3}
                                defaultValue={ decodeHtmlEntities(note?.content)}
                                onChange={(e) => note.tempEdit = e.target.value}
                                spellCheck={true}
                            />
                            <Box sx={{ mt: 1, display: "flex", gap: 1 }}>
                                <IconButton onClick={() => handleEditSave(note.id, note.tempEdit ?? note.content)}>
                                    <CheckCircleIcon />
                                </IconButton>
                                <IconButton onClick={() => handleEditToggle(note.id)}>
                                    <CancelIcon />
                                </IconButton>
                            </Box>
                            </>
                        ) : (
                            <>
                                <Box className="note-content-wrapper">
                                    <Typography
                                        className={`note-content ${note.expanded ? 'expanded' : ''}`}
                                        // onClick={() => toggleNoteExpand(note.id)}
                                    >
                                        {decodeHtmlEntities(note.content)}
                                    </Typography>
                                    {!note.expanded && (
                                        <Typography
                                        variant="caption"
                                        color="primary"
                                        sx={{ cursor: 'pointer' }}
                                        onClick={() => toggleNoteExpand(note.id)}
                                        >
                                        Read more
                                        </Typography>
                                    )}
                                    {note.expanded && (
                                        <Typography
                                        variant="caption"
                                        color="primary"
                                        sx={{ cursor: 'pointer' }}
                                        onClick={() => toggleNoteExpand(note.id)}
                                        >
                                        Show less
                                        </Typography>
                                    )}
                                </Box>

                                <Typography className="note-meta" variant="caption">
                                    Added by <strong>{note.author}</strong> on {formatDate(note.createdAt)}
                                    {
                                        note.updatedAt && ( <span> (Edited on {formatDate(note.updatedAt)})</span> )
                                    }
                                </Typography>
                                {(isSuperAdmin == "true" || isAdmin == "true") && <IconButton onClick={() => handleEditToggle(note.id)} size="small">
                                    <EditIcon fontSize="small" />
                                </IconButton>}
                                {(isSuperAdmin == "true" || isAdmin == "true") && <IconButton onClick={() => handleDeleteConfirmation(note.id)} size="small">
                                    <DeleteIcon fontSize="small" />
                                </IconButton>}
                            </>
                        )}
                        <Divider sx={{ my: 1 }} />
                    </Box>
                ))}
            </Box>

            <CustomAlert
                severity={alert.severity}
                show={alert.showAlert}
                header={alert.header}
                message={alert.message}
                onClick={(prevDetails) =>
                    setAlert({ ...prevDetails, showAlert: false })
                }
                alertType={alert.type}
                confirmButton={alert.onConfirm}
                autoclose={alert.severity === "error" ? false : true}
            />

            <CustomAlert
                severity={alertNew.severity}
                show={alertNew.showAlert}
                header={alertNew.header}
                message={alertNew.message}
                onClick={() => {
                    setAlertNew({ ...alertNew, showAlert: false });
                }}
                alertType={alertNew.alertType}
                confirmButton={alertNew.onConfirm}
                autoclose={alertNew.severity === "error" ? false : true}
            />
        </Box>
    );
}

export default UserNotes;